import apiClient from "../api/apiClient";

const analyzerService = {
  uploadImage: async (file, email) => {
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("email", email);

      const response = await apiClient.post("/eyeAnalyzer/analyze", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error uploading eye image:", error);
      throw error.response?.data || { message: "Image upload failed" };
    }
  },
  getSupplements: async (imgUrl, gptText, email) => {
    try {
      const response = await apiClient.post(
        "/eyeAnalyzer/supplements",
        { imgUrl, gptText, email },
        {}
      );

      return response.data;
    } catch (error) {
      console.error("Error while fetching supplements", error);
      throw error.response?.data || { message: "Image upload failed" };
    }
  },
};

export default analyzerService;
